<!--
 * @Description: 添加用户-单个
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-26 17:01:47
-->
<template>
  <div>
    <p
      style="text-align:center;color:#696969;margin-bottom:30px"
      v-if="!editUserTag"
    >
      添加后的用户本月项目将被直接邀请加入项目。
    </p>

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
    >
      <template v-if="editUserTag">
        <el-form-item label="个体名称：" prop="enterpriseName">
          <el-input
            disabled
            v-model="ruleForm.enterpriseName"
            style="width:230px"
          />
        </el-form-item>
        <el-form-item label="经营者：" prop="fullName">
          <el-input disabled v-model="ruleForm.fullName" style="width:230px" />
        </el-form-item>
      </template>
      <el-form-item label="手机号：" prop="phone">
        <el-input
          :disabled="editUserTag"
          v-model.trim="ruleForm.phone"
          :maxlength="11"
          style="width:230px"
          placeholder="请输入手机号"
        />
      </el-form-item>
      <personLabel :dataObj="ruleForm"></personLabel>
    </el-form>
    <div class="xrk-dialog__btns">
      <el-button type="info" @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </div>
  </div>
</template>

<script>
import { checkPhone } from '@/tools/formCheck';
import { projectPersonnelManagement } from '@/api/ajax';
// 人员标签
import personLabel from '../../components/personLabel/personLabel.vue';

export default {
  name: 'AddUser',
  props: {
    editUserTag: {
      type: Boolean,
      default: false
    },
    defaultObj: {
      type: Object,
      default: () => ({})
    }
  },
  inject: ['_parent'], // src\page\project-personnel-inside\list\index.vue
  components: { personLabel },
  data() {
    return {
      ruleForm: {
        phone: ''
      },
      rules: {
        phone: this.editUserTag
          ? []
          : [
              {
                required: true,
                message: '请输入手机号',
                trigger: 'blur'
              },
              {
                validator: checkPhone,
                message: '请输入有效的手机号',
                trigger: 'blur'
              }
            ]
      }
    };
  },
  methods: {
    cancel() {
      this.$xrkDialog.remove();
    },
    confirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.addUser();
        }
      });
    },
    addUser() {
      let data = {
        projectId: this.$route.query.id,
        ...this.ruleForm
      };
      const { editUserTag } = this;
      projectPersonnelManagement[
        editUserTag ? 'modifyUserTag' : 'addedIndividually'
      ](data).then(params => {
        if (params.data.code === '1') {
          this.$message.success(editUserTag ? '修改成功' : '添加成功');
          try {
            this._parent.$children[0].searchEvent();
          } catch (err) {
            this._parent.tableSearch();
          }
          this.$emit('ok');
          this.$xrkDialog.remove();
        }
      });
    }
  },
  created() {
    if (this.editUserTag) {
      this.ruleForm = {
        ...this.ruleForm,
        ...this.defaultObj
      };
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
</style>
